// extracted by mini-css-extract-plugin
export default {"accordion_item":"Notification_accordion_item__xsSk5","stack":"Notification_stack__Diwbj"};